import React, { useState } from 'react';
import { motion } from 'framer-motion';

interface AnswerInputProps {
  onSubmit: (answer: number) => void;
}

export const AnswerInput: React.FC<AnswerInputProps> = ({ onSubmit }) => {
  const [answer, setAnswer] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    const numAnswer = parseFloat(answer);
    if (isNaN(numAnswer)) {
      setError('Please enter a valid number');
      return;
    }

    onSubmit(numAnswer);
    setAnswer('');
  };

  return (
    <form onSubmit={handleSubmit} className="bg-white/20 rounded-2xl p-8">
      <div className="space-y-4">
        <label className="block text-xl font-medium">
          Enter the next number in the sequence:
        </label>
        
        <input
          type="text"
          value={answer}
          onChange={(e) => setAnswer(e.target.value)}
          className="w-full bg-white/10 border-2 border-white/20 rounded-xl px-4 py-3 text-xl
            focus:outline-none focus:border-white transition-colors"
          placeholder="Your answer..."
        />

        {error && (
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className="text-red-300"
          >
            {error}
          </motion.p>
        )}

        <button
          type="submit"
          className="w-full bg-white text-[#4558C8] py-3 rounded-xl font-bold text-xl
            hover:bg-opacity-90 transition-opacity"
        >
          Check Answer
        </button>
      </div>
    </form>
  );
};